import { BaseEntity } from "../base/base-entity";
import { ProcedureEntity } from "./procedure-entity";

export type ProcedurePresentationType = {
  readonly procedureId: string;
  readonly doorPageMarkdown?: string;
  readonly completePageMarkdown?: string;
};

export class ProcedurePresentation extends BaseEntity {
  public readonly procedureId: string;
  public readonly doorPageMarkdown?: string;
  public readonly completePageMarkdown?: string;

  constructor(base: ProcedurePresentationType) {
    super();
    this.procedureId = base.procedureId;
    this.doorPageMarkdown = base.doorPageMarkdown;
    this.completePageMarkdown = base.completePageMarkdown;
  }

  isEmpty(): boolean {
    return !this.doorPageMarkdown && !this.completePageMarkdown;
  }

  static newFrom(proc: ProcedureEntity): ProcedurePresentation {
    return new ProcedurePresentation({
      procedureId: proc.id,
    });
  }

  static fromJSON(json: ProcedurePresentationType): ProcedurePresentation {
    return new ProcedurePresentation(json);
  }
}
